import { render, staticRenderFns } from "./Call-v2.vue?vue&type=template&id=2845c90a&"
import script from "./Call-v2.vue?vue&type=script&lang=js&"
export * from "./Call-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports